import React, { Fragment, useState, useEffect } from "react";
import PropTypes from "prop-types";
import Header from "components/header";
import SideBar from "components/sidebar/sideBar";
import FormSection from "components/form/FormSection";
import Layout from "components/layout/Layout";
import localization from "assets/localization/localization";
import Dashboard from "components/dashboard/Dashboard";
import DashboardNew from "components/dashboard/DashboardNew";
import './Home.css';
const Home = ({
  viewCart,
  match,
}) => {
  const [activeComponent, setActiveComponent] = useState();
  const leadData=[
    {code:"ALL",value:"Lead Count",count:656},
    {code:"ACTIVE",value:"Approved Lead Count",count:434},
    {code:"INACTIVE",value:"Rejected Lead Count",count:212},
  ];

  const crmLeadData=[
    {code:"ALL",value:"Lead Count",count:656},
    {code:"ACTIVE",value:"Approved Lead Count",count:434},
    {code:"INACTIVE",value:"Rejected Lead Count",count:212},
  ];
 
  localStorage.removeItem("sidenav");
  return (
      <Fragment>
        <Header
          viewCart={viewCart}
        />
        <div className="body-container">
          <SideBar
            activeComponent={activeComponent}
            match={match}
          />
          <Layout title={localization.dashboard} isLoading={false} className="dashboard-layout">
            {/* <FormSection className="dashboard-form-section"> 
              <Dashboard />
            </FormSection> */}
              <DashboardNew />
          </Layout>
        </div>
      </Fragment>
  );
};

Home.propTypes = {
  match: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
};

export default Home;
